import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../components/Button.css";
import "./ResidentLogin.css";

export default function ResidentLogin() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const API = process.env.REACT_APP_API_URL;

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await fetch(`${API}/api/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      let data = {};
      try {
        data = await res.json();
      } catch {
        throw new Error("Server returned empty response");
      }

      if (!res.ok) {
        throw new Error(data.message || "Login failed");
      }

      localStorage.setItem("residentToken", data.token);
      localStorage.setItem("residentName", data.name);
      localStorage.setItem("unitNumber", data.unitNumber);
      localStorage.setItem("residentStatus", data.status);
      localStorage.setItem("residentTower", data.tower);

      if (data.status !== "approved") {
        navigate("/resident/pending");
        return;
      }

      navigate("/resident/dashboard");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="resident-login-shell">
      <div className="resident-login-card">
        <h1 className="resident-login-title">Resident Login</h1>

        {error && <div className="resident-login-error">{error}</div>}

        <form onSubmit={handleLogin} className="resident-login-form">
          <input
            type="email"
            placeholder="Email"
            className="resident-login-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <input
            type="password"
            placeholder="Password"
            className="resident-login-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>

        <p className="resident-login-register-link">
          New resident?{" "}
          <span onClick={() => navigate("/resident/register")}>
            Register here
          </span>
        </p>

        <p className="resident-login-register-link">
          <span onClick={() => navigate("/")}>← Back to Crown Residences</span>
        </p>
      </div>
    </div>
  );
}